"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ProvisioningRecord = exports.NAMESPACE = void 0;
const effect_1 = require("effect");
exports.NAMESPACE = 'Culligan.Device.Manufacturing';
exports.ProvisioningRecord = effect_1.Schema.Struct({
    id: effect_1.Schema.String,
    manufacturingSerialNumber: effect_1.Schema.String,
    dsn: effect_1.Schema.NullOr(effect_1.Schema.String),
    assetTag: effect_1.Schema.NullOr(effect_1.Schema.String),
    sku: effect_1.Schema.NullOr(effect_1.Schema.String),
    fw: effect_1.Schema.NullOr(effect_1.Schema.String),
    factoryName: effect_1.Schema.NullOr(effect_1.Schema.String),
    manufacturedAt: effect_1.Schema.String,
    publicIpAddress: effect_1.Schema.NullOr(effect_1.Schema.String),
    /**
     * The four fields below are written only on a disabled copy, never on an
     * active record. `disabledAt` doubles as the marker the read path filters
     * on, so a record carrying it is excluded from duplicate checks and from
     * the default query.
     */
    disabledAt: effect_1.Schema.optionalWith(effect_1.Schema.String, { exact: true }),
    disabledReason: effect_1.Schema.optionalWith(effect_1.Schema.String, { exact: true }),
    disabledBy: effect_1.Schema.optionalWith(effect_1.Schema.String, { exact: true }),
    originalId: effect_1.Schema.optionalWith(effect_1.Schema.String, { exact: true }),
}).annotations({ identifier: `${exports.NAMESPACE}.ProvisioningRecord` });
//# sourceMappingURL=manufacturing.js.map